import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { SearchActiveFacets } from '@uncinc/react-searchkit';
import type { SearchActiveFacetsProps } from '@uncinc/react-searchkit/dist/components/ActiveFacets';

import './style.scss';

const SearchAllContentActiveFacets: React.FC<SearchActiveFacetsProps> = (props) => {
  const { className, ...restProps } = props;

  const { t } = useTranslation();

  const classNames = c('SearchAllContent__ActiveFacets', className);

  return (
    <SearchActiveFacets
      {...restProps}
      className={classNames}
      showResetAll
      resetAllProps={{
        buttonText: t('searchkit.active_facets.reset_all'),
      }}
      transformItems={(items) => items.map((item) => ({
        ...item,
        refinements: item.refinements.map((refinement) => ({
          ...refinement,
          label: refinement.attribute === 'content_type' ? t(`content_types.${refinement.value}.type`) : refinement.label,
        })),
      }))}
    />
  );
};

export default SearchAllContentActiveFacets;
